export default __webpack_public_path__ + "static/media/road.4aa62d52.png";